import Vue from 'vue';
import * as mTypes from '../../mutation-types';

const state = {
  terminals: [],
  error: null,
};

const getters = {
  terminals: state => state.terminals,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/enabled-terminals`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
}

const mutations = {
  [mTypes.DATA_FETCHED](state, terminals) {
    state.terminals = terminals.data;
    state.error = null;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/kiosks/terminals.js